export default function NoHtmlContent({
  content
}: Readonly<{ content: string }>) {
  const removeHtmlTags = new DOMParser().parseFromString(
    content ?? '',
    'text/html'
  ).body.textContent;
  return removeHtmlTags;
}
